import React, { useState, useEffect, useRef } from "react";
import { TableLoader } from "../../Common/ShimmerLoader";
import { withTranslation } from "react-i18next";
import MUITable from "../../Common/MUITable";
import isGHMC from "../../Common/helper/helpar";
import DownloadExcel from './exportExcel';
import RouteSummaryPathStore from "./store/routeSummaryPathStore";
import { Button, Modal, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import EditRouteSummaryPathModal from "./editRouteSummaryPathModal";

const RouteSummaryPath = ({ t }) => {
    const isProd = isGHMC();
    const { fetchRouteSummaryPathMasters, routeSummaryPathData, loading } = RouteSummaryPathStore();
    const [routeCode, setRouteCode] = useState('');
    const [selectedData, setSelectedData] = useState(null);
    const [lgShow, setLgShow] = useState(false);
    const [editModalShow, setEditModalShow] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [vehicleNumber, setVehicleNumber] = useState('');


    useEffect(() => {
        fetchRouteSummaryPathMasters(routeCode, vehicleNumber);
    }, []);

    const transformedData = routeSummaryPathData.map((item) => ({
        ...item,
        status: item.status ? "Active" : "Inactive",
        routeSupervisor: item.routeSuperVisorName || "N/A",
        zone: item.zoneName || "N/A",
        circle: item.circleName || "N/A",
        hasVehicle: !!(item.vehicleNumber && item.vehicleNumber !== "N/A"),
        hasDriver: !!(item.driverName && item.driverName !== "N/A")
    }));

    const searchRouteHandler = (e) => {
        setRouteCode(e.target.value);
    };

    const searchVehicleHandler = (e) => {
        setVehicleNumber(e.target.value);
    };

    const handleSearchClick = () => {
        setRouteCode(routeCode);
        setVehicleNumber(vehicleNumber);
        fetchRouteSummaryPathMasters(routeCode, vehicleNumber);
    };

    const handleShow = (row) => {
        const collectionPoints = row.collectionPointNames?.map((name, index) => ({
            collectionPointCode: index + 1,
            collectionPointName: name
        })) || [];
        setModalData(collectionPoints);
        setLgShow(true);
    };

    const handleEditRoute = (row) => {
        if (row && Object.keys(row).length > 0) {
            const cleanedRow = {
                ...row,
                routeSupervisorId: row.routeSupervisorID || "N/A",
                hasVehicle: !!(row.vehicleNumber && row.vehicleNumber !== "N/A"),
                hasDriver: !!(row.driverName && row.driverName !== "N/A"),
                vehicleId: row.vehicleId || row.vehicleID || "",
                driverId: row.driverId || row.driverID || ""
            };
            setSelectedData(cleanedRow);
            setEditModalShow(true);
        }
    };

    const routeSummaryPathHeadingColumns = [
        {
            label: "Route Code",
            field: "routeCode",
            render: (row) => row.routeCode || "N/A",
        },
        {
            label: <>Starting Point<br />Code</>,
            field: "startingCollectionPointCode",
            render: (row) => row.startingCollectionPointCode || "N/A",
        },
        {
            label: <>Starting Point<br />Name</>,
            field: "startingPointName",
            render: (row) => row.startingPointName || "N/A",
        },
        {
            label: <>Ending Point<br />Code</>,
            field: "endingCollectionPointCode",
            render: (row) => row.endingCollectionPointCode || "N/A",
        },
        {
            label: <>Ending Point<br />Name</>,
            field: "endingPointName",
            render: (row) => row.endingPointName || "N/A",
        },
        {
            label: <>Created By <br />(Route Incharge)</>,
            field: "routeSupervisorName",
            render: (row) => row.routeSupervisorName || "N/A",
        },
        {
            label: <>Vehicle Number</>,
            field: "vehicleNumber",
            render: (row) => row.vehicleNumber || "N/A",
        },
        {
            label: <>Driver Name</>,
            field: "driverName",
            render: (row) => row.driverName || "N/A",
        },
        {
            label: <>Collection<br />Points</>,
            field: "countOfCollectionPoints",
            render: (row) => (
                <div
                    style={{
                        cursor: "pointer",
                        color: "blue",
                    }}
                    onClick={() => handleShow(row)}
                >
                    {row.countOfCollectionPoints}
                </div>
            ),
        },
        {
            label: "Zone",
            field: "zoneName",
            render: (row) => row.zoneName || "N/A",
        },
        {
            label: "Ward",
            field: "circleName",
            render: (row) => row.circleName || "N/A",
        },
        {
            label: "Status",
            field: "status",
            render: (row) => (row.status === true ? "Active" : "Inactive"),
        },
        {
            label: "Action",
            render: (row, index) => (
                <button
                    className={`${index % 2 === 0 ? "bg-F8CCCD" : "bg-ddefff"} ${isProd ? "edit-ghmc" : "edit-swm"}`}
                    onClick={() => handleEditRoute(row)}
                >
                    <FontAwesomeIcon icon={faEdit} />
                </button>
            )
        },
    ];

    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header mb-0">
                            <div className="row justify-content-between">
                                <div className="col-md-6">
                                    <div className="d-flex align-items-end gap-2">
                                        <input
                                            placeholder="Search Route Code"
                                            type="text"
                                            className="form-control bg-white"
                                            onChange={searchRouteHandler}
                                            value={routeCode}
                                        />
                                        <input
                                            placeholder="Search Vehicle Number"
                                            type="text"
                                            className="form-control bg-white"
                                            onChange={searchVehicleHandler}
                                            value={vehicleNumber}
                                        />
                                        <button
                                            type="button"
                                            className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                                            style={{ width: '25%' }}
                                            onClick={handleSearchClick}
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="flex_end_middle mb-3">
                                        <DownloadExcel data={transformedData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <div className="top-header">
                                    <h4 style={{ fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' }}>
                                        {t("Route Path Summary")}
                                    </h4>

                                </div>
                                <MUITable loading={loading}
                                    needSRNumber
                                    columns={routeSummaryPathHeadingColumns}
                                    rows={routeSummaryPathData}
                                    tableHeight={500}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                show={lgShow}
                size="md"
                backdrop="static"
                // centered
                onHide={() => setLgShow(false)}
            >
                <Modal.Header >
                    <Modal.Title >{t("Route Points")}</Modal.Title>
                    <i
                        className="fa-solid fa-xmark close-container"
                        style={{ cursor: 'pointer', fontSize: '20px', marginLeft: 'auto' }}
                        onClick={() => setLgShow(false)}
                    ></i>
                </Modal.Header>
                <hr />
                <Modal.Body >
                    <Table bordered >
                        <thead>
                            {/* <tr> */}
                            <th style={{ backgroundColor: '#F7F8FD', padding: '8px', textAlign: 'center', color: '#534D59' }}>
                                <span style={{ color: "#534D59", backgroundColor: "transparent", fontSize: '15px' }}>
                                    {t("Route Point Code")}
                                </span>
                            </th>
                            <th style={{ backgroundColor: '#F7F8FD', padding: '8px', textAlign: 'center', color: '#534D59' }}>
                                <span style={{ color: "#534D59", backgroundColor: "transparent", fontSize: '15px' }}>
                                    {t("Route Point Name")}
                                </span>
                            </th>
                            {/* </tr> */}
                        </thead>
                        <tbody>
                            {modalData.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ padding: '8px', textAlign: 'center' }}>{item.collectionPointCode}</td>
                                    <td style={{ padding: '8px', textAlign: 'center' }}>{item.collectionPointName}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer >
                    <Button
                        variant="dark"
                        style={{ backgroundColor: '#000000', border: 'none', padding: '8px 20px', fontSize: '16px' }}
                        onClick={() => setLgShow(false)}
                    >
                        {t("OK")}
                    </Button>
                </Modal.Footer>
            </Modal>
            {editModalShow ?
                <EditRouteSummaryPathModal
                    show={editModalShow}
                    onHide={() => setEditModalShow(false)}
                    data={selectedData}
                    t={t}
                />
                : ''}
        </>
    );
};

export default withTranslation()(RouteSummaryPath);